import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import { formatNum } from "../Utils/date";
import {
  formatCalendarDate,
  addClickRecord,
  formatPhoneNumber,
  getCaseId,
  getClientId,
} from "../Utils/helper";
// import { showModal } from "../Redux/modal/actions";
import {
  // fetchClientProvider,
  // fetchClientProviderVerifications,
  fetchCasePageClientProviders,
} from "../api/clientProviders";
import {
  setClientProviders,
  // setEditCaseProvider,
  setLoading,
  // setVerifications,
} from "../Redux/client-providers/clientProviderSlice";
import { setComponentLoadingEffect } from "../Redux/common/Loader/action";
import MedicalProviderPlaceholder from "../Components/CaseDashboard/MedicalProvidersTable/MedicalProviderPlaceholder";
import ClientProvidersStyles from "../Components/CaseDashboard/ClientProvidersStyles";
import "./treatmentSummary.css";
import { useGetCaseSpecialities } from "../Components/TreatmentPage/hooks/useApiResource";
import NewEditCaseProviderModal from "../Components/BP/modals/NewEditCaseProviderModal";

function mixColorWithWhite(hex, percentage) {
  const whitePercentage = (100 - percentage) / 100;

  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);

  // Mix each channel with white
  r = Math.floor(r + (255 - r) * whitePercentage);
  g = Math.floor(g + (255 - g) * whitePercentage);
  b = Math.floor(b + (255 - b) * whitePercentage);

  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
}

const LightBgParagraph = styled.p`
  background-color: ${({ speciality }) => mixColorWithWhite(speciality?.color, 10)} !important;
`;

const LightBgParagraph2 = styled.div`
  background-color: ${({ speciality }) => mixColorWithWhite(speciality?.color, 10)} !important;
  height: 25px !important;
  min-width: 25px !important;
  width: 25px !important;
  max-width: 25px !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TreatmentSummaryPage = ({ activeSpecialty, firmName, refetchAll, providers }) => {
  const dispatch = useDispatch();
  const client_providers = useSelector((state) => state.clientProvider.all);
  // const show = useSelector((state) => state.modal.show);
  const { refetch: refetchSpecial } = useGetCaseSpecialities();
  const medicalProvidersLoading = useSelector(
    (state) => state?.loadEffect?.componentLoadStates?.medicalProviders
  );
  const [fakeRows, setFakeRows] = useState([]);
  const tableWrapperRef = useRef(null);
  const filteredClientProviders = React.useMemo(() => {
    if (!client_providers) return [];

    if (activeSpecialty === "all") {
      return client_providers;
    }

    return client_providers.filter(
      (provider) => String(provider?.specialty?.id) === String(activeSpecialty)
    );
  }, [client_providers, activeSpecialty]);

  // const fillTable = () => {
  //   const tableWrapper = tableWrapperRef.current;
  //   const tableBody = document.getElementById("table-body");

  //   if (tableWrapper && tableBody) {
  //     const tableHeight = tableWrapper.clientHeight;
  //     console.log(tableHeight);
  //     const tableBodyHeight = tableHeight - 25;
  //     const rowHeight = tableBody.firstChild?.offsetHeight || 25;
  //     const existingRows = filteredClientProviders?.length || 0;
  //     const rowsToFill = Math.ceil(tableBodyHeight / rowHeight) - existingRows;

  //     setFakeRows(
  //       rowsToFill > 0 ? Array.from({ length: rowsToFill }, (_, i) => ({ id: `empty-${i}` })) : []
  //     );
  //   }
  // };

  const [needsScroll, setNeedsScroll] = useState(false);

  const fillTable = () => {
    const tableWrapper = tableWrapperRef.current;
    const tableBody = document.getElementById("table-body");
    if (!tableWrapper || !tableBody) return;

    const tableHeight = tableWrapper.clientHeight;
    const tableBodyHeight = tableHeight - 25;
    const rowHeight = tableBody.firstChild?.offsetHeight || 25;
    const existingRows = filteredClientProviders?.length || 0;
    const realRowsHeight = existingRows * rowHeight;

    if (realRowsHeight > tableBodyHeight) {
      setNeedsScroll(true);
      setFakeRows([]);
      return;
    }

    setNeedsScroll(false);
    const rowsToFill = Math.floor((tableBodyHeight - realRowsHeight) / rowHeight);
    setFakeRows(
      rowsToFill > 0 ? Array.from({ length: rowsToFill }, (_, i) => ({ id: `empty-${i}` })) : []
    );
  };
  useEffect(() => {
    fillTable();
    window.addEventListener("resize", fillTable);
    return () => window.removeEventListener("resize", fillTable);
  }, [filteredClientProviders]);

  useEffect(() => {
    setLoading({
      key: "all",
      value: true,
    });

    dispatch(setComponentLoadingEffect("medicalProviders", true));
    fetchCasePageClientProviders(getClientId(), getCaseId())
      .then((data) => {
        dispatch(setClientProviders(data?.results));
        setLoading({
          key: "all",
          value: false,
        });
        dispatch(setComponentLoadingEffect("medicalProviders", false));
      })
      .catch((error) => {
        console.error("Error occurred while fetching client-providers", error);
        dispatch(setComponentLoadingEffect("medicalProviders", false));
        setLoading({
          key: "all",
          value: false,
        });
      });
  }, [dispatch]);

  const adjustCaseDetailsWidths = () => {
    const columnClasses = [
      "medical-provider-summary",
      "phone-provider-summary",
      "first-provider-summary",
      "last-provider-summary",
      "visit-provider-summary",
      "record-provider-summary",
      "bill-provider-summary",
      "original-provider-summary",
      "lien-provider-summary",
    ];

    columnClasses.forEach((className) => {
      const elements = document.querySelectorAll(`.${className}`);

      let maxWidth = 0;

      elements.forEach((el) => {
        const width = el.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
      });

      elements.forEach((el) => {
        el.style.width = `${maxWidth}px`;
        el.style.minWidth = `${maxWidth}px`;
        el.style.maxWidth = `${maxWidth}px`;
      });
    });
  };

  useEffect(() => {
    adjustCaseDetailsWidths();

    window.addEventListener("resize", adjustCaseDetailsWidths);
    return () => {
      window.removeEventListener("resize", adjustCaseDetailsWidths);
    };
  }, [filteredClientProviders]);
  const [activeTab, setActiveTab] = useState("Treatment-Location");

  const [caseProviderShow, setCaseProviderShow] = useState(false);
  const handleCaseProviderClose = () => {
    fetchCasePageClientProviders(getClientId(), getCaseId())
      .then((data) => {
        dispatch(setClientProviders(data?.results));
        setLoading({
          key: "all",
          value: false,
        });
        dispatch(setComponentLoadingEffect("medicalProviders", false));
      })
      .catch((error) => {
        console.error("Error occurred while fetching client-providers", error);
        dispatch(setComponentLoadingEffect("medicalProviders", false));
        setLoading({
          key: "all",
          value: false,
        });
      });
    setCaseProviderShow(false);
  };
  const [selectedProvider, setSelectedProvider] = useState([]);
  const handleCaseProviderShow = (id) => {
    setCaseProviderShow(true);
    const a = providers?.find((p) => p.id === id);
    if (Object.keys(a).length > 0) {
      setSelectedProvider(a);
    }
  };
  const [allTreatmentDates, setAllTreatmentDates] = useState([]);
  const [, setDates] = useState([
    {
      date: "",
    },
    {
      date: "",
    },
  ]);
  const [, setVisits] = useState(0);
  return (
    <div
      ref={tableWrapperRef}
      className="treatment-summary-wrapper m-b-5"
      style={{
        // height: "100%",
        overflowY: needsScroll ? "scroll" : "hidden",
        scrollbarWidth: "none",
        // paddingBottom: "25px",
        width: "100%",
      }}
    >
      {caseProviderShow && (
        <NewEditCaseProviderModal
          show={caseProviderShow}
          firmName={firmName}
          handleClose={() => {
            addClickRecord(999, 8);
            handleCaseProviderClose();
          }}
          visits={selectedProvider?.visits}
          dates={[
            {
              date: selectedProvider?.first_date?.split("T")[0],
            },
            {
              date: selectedProvider?.second_date?.split("T")[0],
            },
          ]}
          setDates={setDates}
          setVisits={setVisits}
          caseProvider={selectedProvider}
          specialitie={selectedProvider?.specialty}
          contact={selectedProvider?.treatment_location}
          treatmentBill={selectedProvider?.billing_request}
          paidBill={selectedProvider?.billing_request_paid}
          treatmentRecord={selectedProvider?.records_request}
          paidRecords={selectedProvider?.records_request_paid}
          lienHolder={selectedProvider?.lien_holder}
          allTreatmentDates={allTreatmentDates}
          setAllTreatmentDates={setAllTreatmentDates}
          verification={selectedProvider?.verification?.verification_info}
          refetchAll={refetchAll}
          refetch={refetchAll}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      )}
      <table
        className="table table-borderless table-striped table-treatment has-specialty-icon has-height-25"
        id="treatment-summary-table"
      >
        <thead
          style={{
            position: "sticky",
            top: "0px",
          }}
        >
          <tr id="tb-header">
            <th
              className="text-center"
              style={{
                minWidth: "25px",
                width: "25px",
                maxWidth: "25px",
              }}
            >
              {" "}
              {/* Index Header  */}
            </th>
            <th
              style={{
                minWidth: "25px",
                width: "25px",
                maxWidth: "25px",
              }}
              className="text-center"
              id="th-tf"
            >
              TF
            </th>

            <th className="td-autosize color-grey-2 p-l-5 text-center medical-provider-summary">
              Medical Provider
            </th>
            <th className="text-center color-grey-2 phone-provider-summary">Phone</th>
            <th />

            <th className="text-center color-grey-2 first-provider-summary">First</th>
            <th />
            <th className="text-center color-grey-2 last-provider-summary">Last</th>
            <th />
            <th className="text-center color-grey-2 visit-provider-summary">Visits</th>
            <th />
            <th className="text-center color-grey-2 record-provider-summary">Records</th>
            <th />
            <th className="text-center color-grey-2 bill-provider-summary">Bills</th>
            <th />
            <th className="text-end color-grey-2 original-provider-summary">Original</th>
            <th />

            <th className="text-center color-grey-2 lien-provider-summary">Lien</th>
          </tr>
        </thead>
        <tbody id="table-body" className={`has-speciality-color-${activeSpecialty}`}>
          {!medicalProvidersLoading ? (
            filteredClientProviders && filteredClientProviders.length > 0 ? (
              filteredClientProviders?.map((client_provider, index) => (
                <>
                  <ClientProvidersStyles
                    clientProviders={[{ specialty: { ...client_provider?.specialty } }]}
                  />
                  <tr
                    className={
                      activeSpecialty !== "all"
                        ? `has-speciality-color-${activeSpecialty} ${index % 2 === 0 ? "bg-speciality-2" : "bg-speciality-4"}`
                        : `has-speciality-color-${client_provider?.specialty?.id} ${index % 2 === 0 ? "bg-speciality-2 hover-background-row" : "bg-speciality-4 hover-background-row"}`
                    }
                    id="treatment-summary-row"
                    data-table_id={36}
                    onClick={() => {
                      handleCaseProviderShow(client_provider?.id);
                    }}
                    // onClick={() => {
                    //   if (!show) {
                    //     addClickRecord(999, page_id_click_record);
                    //     dispatch(showModal());
                    //     dispatch(
                    //       setLoading({
                    //         key: "editCaseProvider",
                    //         value: true,
                    //       })
                    //     );
                    //     fetchClientProvider(client_provider.id)
                    //       .then((data) => {
                    //         dispatch(setEditCaseProvider(data));
                    //         dispatch(
                    //           setLoading({
                    //             key: "editCaseProvider",
                    //             value: false,
                    //           })
                    //         );
                    //       })
                    //       .catch(() => {
                    //         dispatch(
                    //           setLoading({
                    //             key: "editCaseProvider",
                    //             value: false,
                    //           })
                    //         );
                    //       });
                    //     fetchClientProviderVerifications(client_provider.id, "CaseProviders")
                    //       .then((verificationData) => {
                    //         dispatch(setVerifications(verificationData));
                    //       })
                    //       .catch((err) => {
                    //         console.error("Error Occurred fetchClientProviderVerifications", err);
                    //       });
                    //   }
                    // }}
                  >
                    <ClientProvidersStyles
                      clientProviders={[{ specialty: { ...client_provider?.specialty } }]}
                    />
                    <td className={"color-black"} id="treatment-summary-index">
                      <LightBgParagraph2
                        speciality={
                          client_provider?.specialty || {
                            color: "#19395f",
                            secondary_color: "#75889f",
                          }
                        }
                      >
                        {index + 1}
                      </LightBgParagraph2>
                    </td>

                    <td className={"color-black"} id="treatment-summary-index">
                      <LightBgParagraph2
                        speciality={
                          client_provider?.specialty || {
                            color: "#19395f",
                            secondary_color: "#75889f",
                          }
                        }
                      >
                        <div className="d-flex align-items-center">{/* Empty */}</div>
                      </LightBgParagraph2>
                    </td>

                    {client_provider.profile_pic ? (
                      <td className={"td-autosize color-black"} id="index-summary-provider">
                        <LightBgParagraph
                          speciality={
                            client_provider?.specialty || {
                              color: "#19395f",
                              secondary_color: "#75889f",
                            }
                          }
                        >
                          <div
                            className="d-flex align-items-center"
                            style={{ width: "fit-content" }}
                          >
                            <span
                              className="d-flex align-items-center justify-content-center text-center text-white specialty-icon speciality-box"
                              style={{
                                backgroundColor: `${client_provider?.specialty?.color}`,
                              }}
                            >
                              {client_provider?.specialty?.name[0]}
                            </span>
                            <p className="p-l-5 p-r-5" style={{ fontWeight: "600" }}>
                              {client_provider?.treatment_location?.name
                                ? client_provider?.treatment_location?.name
                                : null}
                            </p>
                          </div>
                        </LightBgParagraph>
                      </td>
                    ) : (
                      <td className="td-autosize color-black" id="index-summary-provider">
                        <LightBgParagraph
                          speciality={
                            client_provider?.specialty || {
                              color: "#19395f",
                              secondary_color: "#75889f",
                            }
                          }
                        >
                          <div
                            className="d-flex align-items-center"
                            style={{ width: "fit-content" }}
                          >
                            <span
                              className="d-flex align-items-center justify-content-center text-center text-white specialty-icon speciality-box"
                              style={{
                                backgroundColor: `${client_provider?.specialty?.color}`,
                              }}
                            >
                              {client_provider?.specialty?.name[0]}
                            </span>
                            <p className="p-l-5 p-r-5" style={{ fontWeight: "600" }}>
                              {client_provider?.treatment_location?.name
                                ? client_provider?.treatment_location?.name
                                : null}
                            </p>
                          </div>
                        </LightBgParagraph>
                      </td>
                    )}

                    <td className="td-autosize" style={{ fontWeight: "600" }}>
                      {client_provider?.treatment_location && (
                        <>{formatPhoneNumber(client_provider?.treatment_location?.phone_number)}</>
                      )}
                    </td>
                    <td />
                    {/* <!-- Column 3: First Date --> */}
                    <td className="td-autosize">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ gap: "5px" }}
                      >
                        {/* <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "max-content" }}
                        >
                          {client_provider?.verification_details?.first_date?.verified ? (
                            client_provider?.verification_details?.first_date?.details[0]
                              ?.profile_pic ? (
                              <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img">
                                <img
                                  src={
                                    client_provider?.verification_details?.first_date.details[0]
                                      ?.profile_pic
                                  }
                                  alt={
                                    client_provider?.verification_details?.first_date.details[0]
                                      ?.date
                                  }
                                  className="ps-0"
                                />
                              </span>
                            ) : (
                              <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img" />
                            )
                          ) : (
                            <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img" />
                          )}
                        </div> */}
                        <div style={{ fontWeight: "600" }}>
                          {/* {client_provider?.bp_treatment_notes &&
                            [...client_provider.bp_treatment_notes]
                              .sort((a, b) => new Date(a.date) - new Date(b.date))
                              .map((note, index) =>
                                index === 0 ? (
                                  <span key={note.id}>{formatDate(note.date)}</span>
                                ) : null
                              )} */}
                          {formatCalendarDate(client_provider?.first_date)}
                        </div>
                        {/* <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "max-content" }}
                        >
                          {client_provider?.verification_details?.first_date?.verified ? (
                            <i className="ic ic-verified ic-19" />
                          ) : (
                            <i className="ic ic-unverified ic-19" />
                          )}
                        </div> */}
                      </div>
                    </td>

                    <td />
                    <td className="td-autosize">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ gap: "5px" }}
                      >
                        {/* <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "max-content" }}
                        >
                          {client_provider?.verification_details?.second_date?.verified ? (
                            client_provider?.verification_details?.second_date?.details[0]
                              ?.profile_pic ? (
                              <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img">
                                <img
                                  src={
                                    client_provider?.verification_details?.second_date?.details[0]
                                      ?.profile_pic
                                  }
                                  alt=""
                                  className="ps-0"
                                />
                              </span>
                            ) : (
                              <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img" />
                            )
                          ) : (
                            <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img" />
                          )}
                        </div> */}
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ fontWeight: "600" }}
                        >
                          {/* {client_provider?.bp_treatment_notes &&
                            [...client_provider.bp_treatment_notes]
                              .sort((a, b) => new Date(a.date) - new Date(b.date))
                              .map((note, index) =>
                                index === 0 ? (
                                  <span key={note.id}>{formatDate(note.date)}</span>
                                ) : null
                              )} */}
                          {formatCalendarDate(client_provider?.second_date)}
                        </div>
                        {/* <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "max-content" }}
                        >
                          {client_provider?.verification_details?.second_date?.verified ? (
                            <i className="ic ic-verified ic-19" />
                          ) : (
                            <i className="ic ic-unverified ic-19" />
                          )}
                        </div> */}
                      </div>
                    </td>

                    <td />

                    {/* <!-- Column 2: Visits Count --> */}
                    <td className="td-autosize" style={{ width: "19px" }}>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ gap: "5px", fontWeight: "600" }}
                      >
                        {/* <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "max-content" }}
                        >
                          {client_provider?.verification_details?.visits?.verified ? (
                            client_provider?.verification_details?.visits?.details[0]
                              ?.profile_pic ? (
                              <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img">
                                <img
                                  src={
                                    client_provider?.verification_details?.visits?.details[0]
                                      ?.profile_pic
                                  }
                                  alt=""
                                  className="ps-0"
                                />
                              </span>
                            ) : (
                              <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img" />
                            )
                          ) : (
                            <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img" />
                          )}
                        </div> */}
                        {client_provider?.visits === "_" ? (
                          <span
                            style={{
                              width: "5px",
                            }}
                          />
                        ) : (
                          <span>{client_provider?.visits}</span>
                        )}
                        {/* <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "max-content" }}
                        >
                          {client_provider?.verification_details?.visits?.verified ? (
                            <i className="ic ic-verified ic-19" />
                          ) : (
                            <i className="ic ic-unverified ic-19" />
                          )}
                        </div> */}
                      </div>
                    </td>

                    <td />

                    {/* <!-- Column 2: Record Received Status --> */}
                    <td className="color-black td-autosize">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ gap: "5px" }}
                      >
                        {/* <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "max-content" }}
                        >
                          {client_provider?.verification_details?.record_received?.verified ? (
                            client_provider?.verification_details?.record_received?.details[0]
                              ?.profile_pic ? (
                              <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img">
                                <img
                                  src={
                                    client_provider?.verification_details?.record_received
                                      ?.details[0]?.profile_pic
                                  }
                                  alt=""
                                  className="ps-0"
                                />
                              </span>
                            ) : (
                              <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img" />
                            )
                          ) : (
                            <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img" />
                          )}
                        </div> */}
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ fontWeight: "600" }}
                        >
                          {client_provider?.record_received ? (
                            <span>
                              Received {formatCalendarDate(client_provider?.record_received)}
                            </span>
                          ) : (
                            <span>Waiting</span>
                          )}
                        </div>
                        {/* <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "max-content" }}
                        >
                          {client_provider?.verification_details?.record_received?.verified ? (
                            <i className="ic ic-verified ic-19" />
                          ) : (
                            <i className="ic ic-unverified ic-19" />
                          )}
                        </div> */}
                      </div>
                    </td>

                    <td />

                    {/* <!-- Column 2: Billing Received Status --> */}
                    <td className="color-black td-autosize" id="medical-provider-no-padding">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ gap: "5px" }}
                      >
                        {/* <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "max-content" }}
                        >
                          {client_provider?.verification_details?.billing_received?.verified ? (
                            client_provider?.verification_details?.billing_received?.details[0]
                              ?.profile_pic ? (
                              <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img">
                                <img
                                  src={
                                    client_provider?.verification_details?.billing_received
                                      ?.details[0]?.profile_pic
                                  }
                                  alt=""
                                  className="ps-0"
                                />
                              </span>
                            ) : (
                              <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img" />
                            )
                          ) : (
                            <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img" />
                          )}
                        </div> */}
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ fontWeight: "600" }}
                        >
                          {client_provider?.billing_received ? (
                            <span>
                              Received {formatCalendarDate(client_provider.billing_received)}
                            </span>
                          ) : (
                            <span>Waiting</span>
                          )}
                        </div>
                        {/* <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "max-content" }}
                        >
                          {client_provider?.verification_details?.billing_received?.verified ? (
                            <i className="ic ic-verified ic-19" />
                          ) : (
                            <i className="ic ic-unverified ic-19" />
                          )}
                        </div> */}
                      </div>
                    </td>

                    <td />
                    <td className="td-autosize">
                      {client_provider?.amount > 0 ? (
                        <div className="text-end" style={{ fontWeight: "600" }}>
                          $ {formatNum(client_provider?.amount)}
                        </div>
                      ) : (
                        <div className="text-end text-primary-50" style={{ fontWeight: "600" }}>
                          $ {formatNum(client_provider?.amount)}
                        </div>
                      )}
                    </td>
                    <td />

                    <td className="td-autosize">
                      {client_provider?.final > 0 ? (
                        <div
                          className="text-end p-r-5"
                          style={{ fontWeight: "600" }}
                          // id="medicalProviderFinalBalance"
                        >
                          $ {formatNum(client_provider?.final)}
                        </div>
                      ) : (
                        <div
                          className="text-end text-primary-50 p-r-5"
                          style={{ fontWeight: "600" }}
                          // id="medicalProviderFinalBalance"
                        >
                          $ {formatNum(client_provider?.final)}
                        </div>
                      )}
                    </td>
                  </tr>
                </>
              ))
            ) : (
              <>
                <MedicalProviderPlaceholder refetchSpecial={refetchSpecial} />
              </>
            )
          ) : (
            fakeRows.map((row, index) => (
              <tr className={index % 2 === 0 ? "bg-primary-2" : "bg-primary-4"} key={row.id}>
                <td colSpan={18} style={{ height: "25px" }} />
              </tr>
            ))
          )}
          {fakeRows.map((row, index) => {
            const globalIndex = filteredClientProviders?.length + index;

            return (
              <tr
                className={`height-25 has-speciality-color-${activeSpecialty} ${
                  globalIndex % 2 === 0 ? "bg-speciality-2" : "bg-speciality-4"
                }`}
                key={row.id}
              >
                <td colSpan={18} style={{ height: "25px" }} />
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TreatmentSummaryPage;
